<template>
    <div class="card-promotion">
        <a :href="item.href" :title="item.title" class="card">
            <div class="card__body card__body--link">
                <header class="card__topbar">
                    <div class="m-right--auto">
                        <!-- @slot Content for the top left corner. -->
                        <slot name="corner-top-left">
                            <dk-badge v-if="item.badge" :name="item.badge.id">
                                {{ item.badge.label }}
                            </dk-badge>
                        </slot>
                    </div>
                    <div v-if="item.discountPercentage" class="card-promotion__badge d--flex">
                        <span class="color--promo ts--body-small ts-weight--900">{{ item.discountPercentage }}</span>
                        <span class="color--grey-900 ts--micro ts--uppercase ts--truncate">
                            {{ $t('card-promotion.discount') }}
                        </span>
                    </div>
                </header>

                <figure class="card__img">
                    <component
                        :is="hasDeferredImg ? 'deferred-img' : 'img'"
                        :src="hasDeferredImg ? getPrismImageUrl(item.cover, 400) : fakeImg"
                        :data-src="hasDeferredImg ? null : getPrismImageUrl(item.cover, 400)"
                        :data-srcset="hasDeferredImg ? null : srcset"
                        :alt="item.title"
                        :title="item.title"
                        :class="{ lazyload: !hasDeferredImg }"
                        :sizes="hasDeferredImg ? null : sizes"
                    />
                </figure>

                <div class="ts-align--center m-top--xxs m-bottom--0">
                    <h4 class="ts--caption color--grey-900 ts--uppercase ts--truncate">
                        {{ item.make }}
                    </h4>

                    <h3 class="ts--body-big ts-weight--900 color--grey-900 ts--truncate">
                        {{ item.model }}
                    </h3>

                    <!-- @slot Content below the make and model text. -->
                    <slot>
                        <h4 class="ts--caption ts--lowercase">
                            <div v-if="item.finalPrice" class="color--promo">
                                <span class="m-right--xxs">{{ $t('card-promotion.from') }}</span>
                                <span class="card-promotion__old-price color--grey-900 ts--line-through">
                                    {{ item.originalPrice }}
                                </span>
                                <span class="m-left--xxs">{{ item.finalPrice }}</span>
                            </div>
                            <div v-else class="color--grey-900">
                                <span class="m-right--xxs">{{ $t('card-promotion.from') }}</span>
                                <span>{{ item.originalPrice }}</span>
                            </div>
                        </h4>
                    </slot>
                </div>
            </div>
            <div class="card__footer">
                <!-- @slot Content for the bottom left corner. -->
                <slot name="corner-bottom-left">
                    <div class="card-promotion__icons">
                        <icon
                            v-if="item.has360"
                            name="generic-360"
                            size="xs"
                            color="grey-600"
                            class="m-right--xs card-promotion__icon"
                        />
                        <icon
                            v-if="item.has0100"
                            name="generic-video"
                            size="xs"
                            color="grey-600"
                            class="card-promotion__icon"
                        />
                    </div>
                </slot>
                <!-- @slot Content for the bottom right corner. -->
                <slot name="corner-bottom-right">
                    <div class="color--primary ts--small ts-weight--700">
                        {{ $tc('card-promotion.version', item.numVersions, { n: item.numVersions }) }}
                    </div>
                </slot>
            </div>
        </a>
    </div>
</template>

<script>
import DeferredImg from '@v4/common/components/atoms/DeferredImg.vue';
import DkBadge from '@v4/common/components/atoms/DkBadge.vue';
import Icon from '@v4/common/components/atoms/Icon';
import { fakeImg } from '@v4/common/utils';
import { getPrismImageUrl } from '@v4/common/utils/image';

/**
 * Card promotion
 *
 * @version 4.0.0
 * @example ./examples/CardPromotion.md
 */
export default {
    name: 'CardPromotion',
    components: {
        DeferredImg,
        DkBadge,
        Icon,
    },
    props: {
        /**
         * Card item
         */
        item: {
            type: Object,
            default: () => ({}),
        },
        /**
         * Defer image loading
         */
        hasDeferredImg: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            fakeImg,
        };
    },
    computed: {
        srcset() {
            return `${getPrismImageUrl(this.item.cover, 250)} 250w,
                ${getPrismImageUrl(this.item.cover, 500)} 500w,
                ${getPrismImageUrl(this.item.cover, 740)} 740w
            `;
        },
        sizes() {
            return `
                (max-width: 360px) 290px,
                (max-width: 500px) 500px,
                (max-width: 1024px) 740px,
                (min-width: 1024px) 290px,
            `;
        },
    },
    methods: {
        getPrismImageUrl,
    },
};
</script>
